import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * 定义 Logo 组件
 */
class Logo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { logo },
        } = this.props;

        return (
            <React.Fragment>
                <a href={logo.url} target="_blank">
                    <img src={logo.src} alt={logo.title} content={logo} width={logo.width} height={logo.height} />
                </a>
                <img className={styles.logo_2} src="//p1.ifengimg.com/a/2016_23/26a9c07a77f503f.jpg" />
            </React.Fragment>
        );
    }
}

export default errorBoundary(Logo);
